/**
 * Copyright © 2012 Goodgame Studios. All rights reserved.
 *
 * Created with IntelliJ IDEA
 * Creator: pburst
 * Created: 20.06.13, 10:47
 *
 * $URL: $
 * $Rev: $
 * $Author: $
 * $Date: $
 * $Id: $
 */

/**
 * Server error ids
 * See https://sites.google.com/a/goodgamestudios.com/tech-wiki/ggs-technical-overview/client-server-shared/core-error-id-constants
 */
export class IdentityManagementConstants {
    // Age check my fail for the registration and the login
    public static ERROR_SERVER_AGE_CHECK_FAILED: number = 10000;
    public static ERROR_SERVER_AGE_CHECK_FAILED_STRING: string = "AGE_CHECK_FAILED";

    // Siren24 errors
    public static ERROR_PARSE: string = "PARSE_ERROR";
    public static ERROR_MISSING_PARAM: string = "MISSING_REQUIRED_PARAMETER";
    public static ERROR_INVALID_PARAM_VAL: string = "INVALID_PARAMETER_VALUE";
    public static ERROR_INVALID_PARAM_LENGTH: string = "INVALID_PARAMETER_LENGTH";
    public static ERROR_GENERAL: string = "GENERAL_ERROR";
    public static ERROR_VERIFICATION_FAILED: number = 24001;

    // ID-check register process
    public static ERROR_SERVER_KOREA_ID_ALREADY_REGISTERED: number = 10001;
    public static ERROR_SERVER_MISSING_KOREA_USER_DATA: number = 10002;
    public static ERROR_SERVER_NO_KOREA_USER_DATA_AVAILABLE: number = 10003;
    public static ERROR_SERVER_AGE_CHECK_FAILED_GAME_NOT_ALLOWED_FOR_AGE: number = 10004;
    public static ERROR_CLIENT_REGISTER_MISSING_KOREA_ID_CHECK: number = 904;
    public static ERROR_CLIENT_REGISTER_AGE_CHECK_FAILED: number = 950;
    public static ERROR_CLIENT_REGISTER_NOT_ALLOWED_FOR_AGE: number = 952;

    // Login
    public static ERROR_CLIENT_LOGIN_AGE_CHECK_FAILED: number = 951;

    // Texts errors
    public static TEXT_ID_ERROR_KOREA_ID_ALREADY_REGISTERED: string = "generic_alert_korea01";
    public static TEXT_ID_ERROR_KOREA_ID_CHECK_FAILED: string = "generic_alert_korea02";
    public static TEXT_ID_ERROR_REGISTER_AGE_CHECK_FAILED: string = "generic_alert_korea03";
    public static TEXT_ID_ERROR_LOGIN_AGE_CHECK_FAILED: string = "generic_alert_korea04";
    public static TEXT_ID_SERVER_MISSING_KOREA_ID_CHECK_DATA: string = "generic_alert_korea05";
    public static TEXT_ID_ERROR_CLIENT_REGISTER_MISSING_KOREA_ID_CHECK: string = "generic_alert_korea06";
    public static TEXT_ID_ERROR_UNDER_TWELVE_CHECK: string = "generic_alert_korea07";

    // Texts license table registration
    public static LICENSE_GAME_NAME: string = "제명";
    public static LICENCE_COMPANY_NAME: string = "상호";

    public static LICENSE_RATING: string = "이용등급";
    public static LICENSE_RATING_NUMBER: string = "등급분류번호";

    public static LICENSE_DATE_OF_RATING_DELIVERY: string = "등급분류일자";
    public static LICENSE_PUBLISHER_NUMBER: string = "배급업신고번호";

    public static LICENSE_KOREAN_COMPANY_NAME: string = "굿게임스튜디오스코리아 유한회사";
    public static LICENSE_AGE_RATING_SUFFIX: string = "세이용가";
    public static LICENSE_NUMBER: string = "제2013-000003호";

    // Texts
    public static TEXT_ID_INITIAL_AGE_RATING_INFO: string = "generic_childProtectionInfo_korea";

    // License refresher
    public static LICENSE_REFRESHER_INITIAL_SHOW_DELAY_SECONDS: number = 4;
    public static LICENSE_SHOW_SCHEDULE_MINUTES: number = 60;
    public static LICENSE_DISPLAY_DURATION_SECONDS: number = 4;

    // shutdown control
    public static ERROR_SHUT_DOWN_ALERT: number = 0;
    public static ERROR_UNDERAGE_LOGOUT: number = 1;

    // shutdown control timer
    public static SHUTDOWN_CONTROL_TIMER: number = 300;  // 5 minutes

    // tracking id's
    public static TRACKING_SIREN24_SUCCESSFUL_ID_CHECK: number = 1;
    public static TRACKING_SIREN24_MISSING_ID_CHECK_DATA: number = 2;
    public static TRACKINg_SIREN24_ID_ALREADY_REGISTERED: number = 3;
    public static TRACKING_SIREN24_AGE_CHECK_FAILED_DURING_REGISTRATION: number = 4;
    public static TRACKING_SIREN24_REGISTER_NOT_ALLOWED_FOR_AGE: number = 5;
    public static TRACKING_SIREN24_GENERAL_VERIFICATION_ERROR: number = 6;
}
